import React, { useState, useEffect, useRef } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FirstTalkSection from './components/FirstTalkSection';
import SocialMediaSection from './components/SocialMediaSection';
import LateNightSection from './components/LateNightSection';
import FirstFightSection from './components/FirstFightSection';
import ProposalSection from './components/ProposalSection';
import BirthdaySection from './components/BirthdaySection';
import WaitingSection from './components/WaitingSection';
import FirstChatAfterSection from './components/FirstChatAfterSection';
import CountdownSection from './components/CountdownSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <FirstTalkSection />
      <SocialMediaSection />
      <LateNightSection />
      <FirstFightSection />
      <ProposalSection />
      <BirthdaySection />
      <WaitingSection />
      <FirstChatAfterSection />
      <CountdownSection />
      <Footer />
    </div>
  );
}

export default App;